import React from "react";
import { Box, Typography } from "@mui/material";
import SimpleBar from "simplebar-react";

const PackageImages = ({ images = [], title = "Package Images" }) => {  
  if (!images || images.length === 0) {
    console.log("No images provided to PackageImages");
    return null;
  }

  const filteredImages = images.filter(url => url !== "" && url !== null && url !== undefined);
  console.log("Filtered images:", filteredImages);

  if (filteredImages.length === 0) {
    console.log("No valid images found after filtering");
    return null;
  }

  return (
    <Box
      sx={{
        borderBottom: "1px solid #E5E5E8",
        paddingBottom: "30px",
      }}
    >
      <Box sx={{ marginLeft: "20px", marginTop: "20px" }}>
        <Typography
          variant="h4"
          sx={{
            textAlign: "left",
            fontSize: "26px",
            fontWeight: "bold",
          }}
        >
          {title}
        </Typography>
      </Box>
      
      <SimpleBar
        forceVisible="x"
        autoHide={true}
        style={{
          overflowX: "auto",
        }}
        className="custom-scrollbar"
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginLeft: "20px",
            marginTop: "20px",
            gap: "20px",
          }}
        >
          {filteredImages.map((url, index) => (
            <Box key={index} sx={{ flexShrink: 0 }}>
              <img
                src={url}
                alt={`package-${index + 1}`}
                style={{
                  height: "120px",
                  width: "120px",
                  minWidth: "120px",
                  minHeight: "120px",
                  maxWidth: "120px",
                  maxHeight: "120px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </Box>
          ))}
        </Box>
      </SimpleBar>
    </Box>
  );
};

export default PackageImages; 